const fallbackTheme = {
  palette: {
    primary: {
      ultraLight: '#EDEDED',
      light: '#D6D6D6',
      main: '#7A7A7A',
      dark: '#626262'
    },
    secondary: {
      ultraLight: '#F4F4F4',
      light: '#787878',
      main: '#616161',
      dark: '#303030'
    },
    error: {
      main: '#a72514',
      light: '#fee5e4'
    },
    success: {
      main: '#286327',
      light: '#dcfddb'
    },
    alert: {
      main: '#725200',
      light: '#ffe7ca'
    },
    info: {
      main: '#195f7f',
      light: '#dbedfd'
    },
    gray: {
      main: '#706f6f',
      light: '#d3d3d3',
      ultraLight: '#f4f4f4',
      megaLight: '#fafafa',
      dark: '#373737',
      25: '#F7F7F8',
      50: '#f1f2f3',
      100: '#e4e5e7',
      200: '#cfd1d3',
      300: '#afb3b6',
      400: '#8d9196',
      500: '#71767a',
      600: '#56595d',
      700: '#424548',
      800: '#27292a',
      900: '#0f0f10'
    },
    black: '#000',
    white: '#fff',
    dataVisualization: {
      highContrast: {
        blueDark: '#002039',
        coral: '#F95D6A',
        purpleDark: '#665191',
        orange: '#FFA600',
        purple: '#A05195',
        orangeDark: '#FF7C43',
        blue: '#3970C1',
        cyan: '#45CEE0',
        pink: '#D12771',
        green: '#B3D849'
      },
      lowContrast: {
        blueDark: '#5283AB',
        coral: '#FCA6AD',
        purpleDark: '#B1A2D0',
        orange: '#FDDFA5',
        purple: '#D4BBFF',
        orangeDark: '#FCC2A9',
        blue: '#96B3DE',
        cyan: '#BAE6FF',
        pink: '#E995BA',
        green: '#DEF895'
      }
    },
    destructive: {
      ultraLight: '#FDF7F7',
      light: '#821212',
      main: '#A91919',
      dark: '#5D0E0E'
    },
    upgrade: {
      main: '#8D30F7',
      light: '#F6F2FF'
    }
  },
  spacingBase: 8,
  borderRadius: {
    XS: '2px',
    S: '4px',
    M: '8px',
    L: '16px',
    XL: '32px'
  },
  breakPoints: {
    mobileLarge: 480,
    tablet: 768,
    tabletLarge: 960,
    desktop: 1280
  },
  typography: {
    fontWeight: {
      light: 200,
      normal: 400,
      semibold: 600,
      bold: 700
    },
    fontSize: {
      XXS: '10px',
      XS: '12px',
      S: '14px',
      M: '16px',
      L: '18px',
      XL: '20px',
      XXL: '24px',
      XXXL: '32px',
      XXXXL: '48px'
    },
    lineHeight: {
      S: '20px',
      M: '24px',
      L: '28px',
      XL: '32px',
      XXL: '48px',
      XXXL: '72px'
    },
    letterSpacing: {
      S: 0,
      M: 1,
      L: 3,
      XL: 5,
      XXL: 8,
      XXXL: 12
    }
  },
  card: {
    borderRadius: {
      mobile: '4px',
      tablet: '8px',
      desktop: '8px'
    }
  },
  elevations: {
    flat1: {
      boxShadow: '0 2px 2px rgba(0, 0, 0, 0.1)',
      zIndex: 1
    },
    flat2: {
      boxShadow: '0 2px 2px rgba(0, 0, 0, 0.1)',
      zIndex: 1000
    },
    above: {
      boxShadow: '0 0 12px rgba(0, 0, 0, 0.1)',
      zIndex: 1000
    },
    sticky: {
      boxShadow: 'none',
      zIndex: 1001
    },
    raised: {
      boxShadow: '0 8px 8px rgba(0, 0, 0, 0.1)',
      zIndex: 1002
    },
    raisedInverted1: {
      boxShadow: '0 -8px 8px rgba(0, 0, 0, 0.1)',
      zIndex: 1002
    },
    raisedInverted2: {
      boxShadow: '0 -8px 8px rgba(0, 0, 0, 0.1)',
      zIndex: 1003
    },
    popout1: {
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
      zIndex: 1004
    },
    popout2: {
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
      zIndex: 1005
    },
    overlay1: {
      boxShadow: '0 0 24px rgba(0, 0, 0, 0.1)',
      zIndex: 1006
    },
    backdrop: {
      boxShadow: 'none',
      zIndex: 1007
    },
    overlay2: {
      boxShadow: '0 0 24px rgba(0, 0, 0, 0.1)',
      zIndex: 1008
    }
  },
  grid: {
    mobile: {
      columns: 4,
      horizontalSpace: 16,
      verticalSpace: 16,
      gutter: 16
    },
    mobileLarge: {
      columns: 4,
      horizontalSpace: 16,
      verticalSpace: 16,
      gutter: 16
    },
    tablet: {
      columns: 12,
      horizontalSpace: 16,
      verticalSpace: 24,
      gutter: 24
    },
    tabletLarge: {
      columns: 12,
      horizontalSpace: 16,
      verticalSpace: 24,
      gutter: 24
    },
    desktop: {
      columns: 12,
      horizontalSpace: 16,
      verticalSpace: 24,
      gutter: 24
    },
    desktopLarge: {
      columns: 12,
      horizontalSpace: 16,
      verticalSpace: 24,
      gutter: 24
    }
  },
  defaultFontFamily: 'Arial',
  fontFaces: [],
  iconSize: {
    small: '16px',
    medium: '20px',
    regular: '24px',
    large: '32px',
    extra_large: '48px'
  }
};

export { fallbackTheme };
//# sourceMappingURL=fallback.js.map
